import React from 'react';
import SignUpButton from './SignUpButton';

interface ConditionalSignUpComponentProps {
  onOpenConsole: () => void;
  pinCount?: number;
  onOpenList?: () => void;
}

const ConditionalSignUpComponent: React.FC<ConditionalSignUpComponentProps> = ({
  onOpenConsole,
  pinCount,
  onOpenList,
}) => {
  return <SignUpButton onOpenConsole={onOpenConsole} pinCount={pinCount} onOpenList={onOpenList} />;
};

export default ConditionalSignUpComponent;
